import React, { useEffect, useState, useCallback, memo } from 'react';

import { useSpring } from '@react-spring/web';
import { useStore, useAuth } from 'hooks';
import { getWindowDimensions, sizeToSlice } from 'utils/dimensions';
import { isMobile } from 'utils/isMobile';
import { addParamURL, getParamURL, replaceParamsURL } from 'utils/url';

import { HeaderSearch } from './HeaderSearch';
import * as T from './interfaces';

export const Container = memo(({ wrapperHeight }: T.IHeaderSearch) => {
  const { user } = useAuth();
  const {
    mapMode,
    changeViewMode,
    changePlacesSuggestion,
    session,
    changeSession,
  } = useStore();
  const [windowDimension, setWindowDimension] = useState(
    sizeToSlice(getWindowDimensions().width) > 2 ? 275 : 215,
  );
  const [isMobileDevice, setIsMobileDevice] = useState(isMobile());

  const [sizeScreenHeigth] = useState(getWindowDimensions().height);

  useEffect(() => {
    function handleResize() {
      const dimensions = sizeToSlice(getWindowDimensions().width);
      setWindowDimension(dimensions > 2 ? 275 : 215);
      setIsMobileDevice(isMobile());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [windowDimension, isMobileDevice]);

  useEffect(() => {
    const dimensions = sizeToSlice(getWindowDimensions().width);

    const sizeHeightHeadersmaller = Number((sizeScreenHeigth / 12).toFixed(2));

    if (dimensions === 0) {
      if (wrapperHeight > 20) {
        setWindowDimension(sizeHeightHeadersmaller);
      } else {
        setWindowDimension(dimensions > 2 ? 275 : 215);
      }
    }
  }, [wrapperHeight]);

  useEffect(() => {
    const param = getParamURL('session');
    !param && addParamURL('session', 'nearStores');

    changeSession(param ? (param as T.TSession) : 'nearStores');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSession = useCallback(
    sess => {
      changeSession(sess);
      replaceParamsURL('session', sess);
    },
    [changeSession, replaceParamsURL],
  );

  const { height } = useSpring({
    from: { height: windowDimension },
    to: {
      height:
        isMobileDevice && mapMode
          ? 215
          : wrapperHeight > 1
          ? 60
          : windowDimension - wrapperHeight,
    },
  });

  return (
    <HeaderSearch
      mode={!mapMode ? 'map' : 'list'}
      onChangeSession={handleChangeSession}
      height={
        isMobileDevice && mapMode
          ? 215
          : wrapperHeight > 1
          ? 60
          : windowDimension - wrapperHeight
      }
      session={user?.signed ? session : 'favoriteStores'}
      onChangeViewMode={changeViewMode}
      changePlacesSuggestions={changePlacesSuggestion}
      contentStyle={{ height }}
      userIsLoggedIn={user?.signed}
    />
  );
});
